// import antdEnUS from 'ant-design-vue/es/locale-provider/en_US'
import momentEU from 'moment/locale/eu'
import global from './en-US/global'

import menu from './en-US/menu'
import setting from './en-US/setting'
import user from './en-US/user'
import dashboard from './en-US/dashboard'
import result from './en-US/result'
import account from './en-US/account'
import permission from './en-US/permission'
import datum from './en-US/datum'
import consumer from './en-US/consumer'
import system from './en-US/system'
import order from './en-US/order'

const components = {
  // antLocale: antdEnUS,
  momentName: 'eu',
  momentLocale: momentEU
}

export default {
  message: '-',

  'layouts.usermenu.dialog.title': 'Message',
  'layouts.usermenu.dialog.content': 'Are you sure you would like to logout?',
  'layouts.userLayout.title': 'Ant Design is the most influential web design specification in Xihu district',
  ...components,
  ...global,
  ...menu,
  ...setting,
  ...user,
  ...dashboard,
  ...result,
  ...account,
  ...permission,
  ...datum,
  ...consumer,
  ...system,
  ...order
}
